import React, { useState } from "react";
import PropTypes from "prop-types";
import { ModalClosed } from "~misc/icons";
import InputField from "~components/Form/components/InputField";
import useUsuario from "~/fetchs/useUsuario";
import { Formik, Form } from "formik";
import useDeclaracao from "~/fetchs/useDuplaCategoria";
import Loader from "~components/Form/components/Loader";


const Modal = ({
  isOpen,
  onClose,
  initialValues,
  setErrorModal,
  setSuccessModal,
  contatoEmail,
  contatoNome,
  contatoTelefone,
  className,
}) => {
  const [loading, setLoading] = useState(false);
  const modalClasses = isOpen ? `fixed inset-0 bg-black bg-opacity-50 z-[999999] ${loading ? "relative spinner__form-active" : "relative"}` : "hidden";
  const overlayClasses = isOpen ? `fixed inset-0 bg-black opacity-50 z-40` : "hidden";

  const { enviarDeclaracao, trilhas, declaracaoSchema } = useDeclaracao();
  const { usuario } = useUsuario();

  const handleSendDeclaration = async (values) => {
    const clientInfo = {
        trilha: trilhas[initialValues?.trilha?.nome] || "",
        codigoCliente: initialValues?.codigo ? String(initialValues.codigo) : "",
        cnpjCliente: initialValues?.documento || "",
        segmentoCliente: initialValues?.grupoSegmento || "",
        vendedor: usuario?.nome || "",
        nomeContato: values?.nomeContato,
        nomeCliente: initialValues?.razaoSocial || "",
        telCliente: values?.telContato,
        telVendedor: usuario?.telefone || "",
        emailCliente: values?.emailContato ,
        emailVendedor: usuario?.email || "",
        ufCliente: initialValues?.endereco?.cidade?.estado?.sigla || "",
    };

    setLoading(true);

    try {
        const response = await enviarDeclaracao(clientInfo);

        if (response?.isSuccess) {
            setSuccessModal(true);
        } else {
            setErrorModal(true);
        }

        onClose();
    } catch (error) {
        console.error("Erro ao enviar declaração:", error);
        setErrorModal(true);

    } finally {
        setLoading(false);
        onClose();
    }
  }

  return (
    <Formik
        initialValues={{
            emailContato: contatoEmail || "",
            nomeContato: contatoNome || "",
            telContato: contatoTelefone || "",
        }}
        validationSchema={declaracaoSchema}
        onSubmit={handleSendDeclaration}
    >

        <div className={modalClasses} data-testid="modal-overlay">
            <div className="fixed inset-0 flex items-center justify-center z-50">
                <div
                    className={`bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative ${className ?? ""}`}
                    data-testid="modal"
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="flex justify-end">
                        <button
                            type="button"
                            onClick={onClose}
                            className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                            data-testid="close-button"
                            aria-label="Fechar modal"
                        >
                        <ModalClosed />
                        </button>
                    </div>

                    <h3 className="font-bold text-2xl max-w-[400px]">Confirme os dados abaixo antes de enviar a declaração!</h3>

                    <div className="mt-2" data-testid="modal-content">
                        <p className="font-bold max-w-[400px] text-red-600">O cliente irá receber um documento por e-mail para assinatura no Docusign declarando ramo de atividade compatível com sua segmentação</p>
                    </div>

                    <Form id={`declaracao`}>

                        <div className="my-5">
                            <InputField
                                labelName="Email de contato cliente:"
                                inputName="emailContato"
                                inputMask="offmask"
                                inputType="text"
                                defaultValue={contatoEmail}
                                hasImage={true}
                                isRequired
                            />
                            <InputField
                                labelName="Nome do contato:"
                                inputName="nomeContato"
                                inputMask="offmask"
                                inputType="text"
                                defaultValue={contatoNome}
                                hasImage={true}
                                isRequired
                            />
                            <InputField
                                labelName="Telefone de contato:"
                                inputName="telContato"
                                inputMask="offmask"
                                inputType="text"
                                defaultValue={contatoTelefone}
                                hasImage={true}
                                isRequired
                            />
                        </div>

                        <p className="font-bold max-w-[400px]">Não se preocupe! Você também será informado sobre o andamento do processo via e-mail</p>

                        <div className="flex justify-center gap-3 mt-3 " data-testid="modal-buttons">

                            <button
                                type="submit"
                                disabled={loading}
                                className={`px-6 py-3 rounded bg-secundaria text-primaria font-bold  hover:bg-white hover:text-secundaria border-2 border-secundaria border-quartenaria transition duration-300 ease-in-out`}
                                data-testid="button-one"
                            >
                                {loading ? "Enviando..." : "Enviar Declaração"}
                            </button>

                        </div>
                    </Form>
                    
                </div>
                <div className={overlayClasses} onClick={onClose}></div>
            </div>
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center z-[999999]">
                    <Loader />
                </div>
            ) }
        </div>
    </Formik>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  contatoEmail: PropTypes.string,
  contatoNome: PropTypes.string,
  contatoTelefone: PropTypes.string,
  className: PropTypes.string,
};

export default Modal;